export const isWeb = () => process.env.PLATFORM === 'web';
export const isElectron = () => process.env.PLATFORM === 'electron';
export const isBridgeApp = () => process.env.PRODUCT === 'bridge';

// export const isWeb = () => false;
// export const isElectron = () => true;
